export default "__VITE_ASSET__cuUCdLiO__"